import { useEffect, useState } from 'react'
import { Card, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { getLegalConfig } from '../../services/config'
import { LEGAL_TERMS_VERSION } from '../../constants/legal'

const { Title, Paragraph, Text } = Typography

interface SectionItem {
  title: string
  paragraphs: string[]
}

interface LegalPageLayoutProps {
  pageTitle: string
  effectiveDate: string
  sections: SectionItem[]
}

export default function LegalPageLayout({ pageTitle, effectiveDate, sections }: LegalPageLayoutProps) {
  const [displayVersion, setDisplayVersion] = useState(LEGAL_TERMS_VERSION)

  useEffect(() => {
    let cancelled = false
    getLegalConfig()
      .then((res) => {
        if (!cancelled && res.data?.legalTermsVersion) {
          setDisplayVersion(res.data.legalTermsVersion)
        }
      })
      .catch(() => {
        // Keep fallback version if config API is temporarily unavailable.
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fb', padding: '32px 16px' }}>
      <div style={{ maxWidth: 920, margin: '0 auto' }}>
        <Card>
          <div style={{ marginBottom: 24 }}>
            <Title level={2} style={{ marginBottom: 8 }}>{pageTitle}</Title>
            <Text type="secondary">版本：{displayVersion}</Text>
            <br />
            <Text type="secondary">生效日期：{effectiveDate}</Text>
          </div>

          {sections.map((section) => (
            <div key={section.title} style={{ marginBottom: 20 }}>
              <Title level={4} style={{ marginBottom: 8 }}>{section.title}</Title>
              {section.paragraphs.map((item, index) => (
                <Paragraph key={`${section.title}-${index}`} style={{ marginBottom: 8 }}>
                  {item}
                </Paragraph>
              ))}
            </div>
          ))}

          <Paragraph type="secondary" style={{ marginTop: 24 }}>
            如有疑問，請聯絡：admin@kyren.io
          </Paragraph>
          <Paragraph style={{ marginBottom: 0 }}>
            <Link to="/">返回登入頁</Link>
          </Paragraph>
        </Card>
      </div>
    </div>
  )
}

